module.exports = __webpack_public_path__ + "6a3266bd.svg";